import { ChangeDetectionStrategy, Component, EventEmitter, Injector, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { ValueAccessor } from '../../value-accessor/value-accessor';

@Component({
    selector: 'sera-toggle',
    templateUrl: './sera-toggle.component.html',
    styleUrls: ['./sera-toggle.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SeraToggleComponent extends ValueAccessor<boolean> implements OnChanges {
    @Input()
    name!: string;

    @Input()
    label: string | null = null;

    @Input()
    isDisabled: boolean = false;

    @Input()
    toggleValue: boolean | null | undefined = false;

    @Input()
    pClass: string = '';

    @Output() toggleChange = new EventEmitter<boolean>();

    constructor(injector: Injector) {
        super(injector);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['toggleValue']) {
            this.value = changes['toggleValue'].currentValue ?? false;
        }
    }
}
